// Detects if the app is running inside the native Capacitor shell (iOS/Android app).
// Used to hide purchase CTAs (Apple Guideline 3.1.1) and web-only UI in the App Store build.
export const isNativeApp = () => {
  try {
    return !!(window.Capacitor && window.Capacitor.isNativePlatform && window.Capacitor.isNativePlatform());
  } catch {
    return false;
  }
};
